<template>
  <div class="px-3 py-3 mb-5 col-24 col-md-11">
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('termsAPolicy')">
        Termos e Política
      </h1>
      <h1 class="title">
        <span v-text="$ml.get('accountTerSubTitle')" class="pb-2"></span>
      </h1>
      <div class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('termsOfUse')">
            Termos de Uso
          </h6>
        </div>

        <div class="card-body p-0">
          <table>
            <tbody>
              <tr>
                <td class="col-24">
                  <div class="section-head text-left">
                    <div class="content-read my-3" v-html="termsHtml"></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header">
          <h6 class="m-0 p-0 light" v-text="$ml.get('privacyPolicy')">
            Política de Privacidade
          </h6>
        </div>

        <div class="card-body p-0">
          <table>
            <tbody>
              <tr>
                <td class="col-24">
                  <div class="section-head text-left">
                    <div class="content-read my-3" v-html="privacyHtml"></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMarkdown, markdownToHtml } from "@/helpers/markdownContent";

export default {
  data() {
    return {
      title: "Termos e Políticas",
      termsHtml: "",
      privacyHtml: "",
    };
  },
  mounted() {
    this.loadData();
  },
  watch: {
    "$ml.current"() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      this.termsHtml = markdownToHtml(getMarkdown("terms", this.$ml.current));
      this.privacyHtml = markdownToHtml(
        getMarkdown("privacy", this.$ml.current),
      );
    },
  },
};
</script>

<style scoped>
</style>
